import { Box, Typography } from "@mui/material";
import { LIDAR_UPLOAD_STATUSES, STATUS_STEPS } from "./constants";
import type { ProjectLidarUploadStatus } from "./schemas";
import t from "./translations";

type Props = {
  projectStatuses: ProjectLidarUploadStatus[];
};

export default function StatusSummary({ projectStatuses }: Props) {
  const summarySteps = LIDAR_UPLOAD_STATUSES.map((step) => ({
    step,
    projectCount: projectStatuses.filter(
      (projectStatus) => projectStatus.status === step
    ).length,
  })).filter(({ projectCount }) => projectCount > 0);

  return (
    <Box
      data-testid="lidar-upload-status.summary"
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
        alignItems: "center",
      }}
    >
      {summarySteps.map(({ step, projectCount }) => (
        <Typography
          key={step}
          variant="body2"
          data-testid={`lidar-upload-status.summary.${step}`}
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 0.75,
            fontVariantNumeric: "tabular-nums",
          }}
        >
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              bgcolor: STATUS_STEPS[step].color,
              boxShadow: "inset 0 0 0 1px rgba(0, 0, 0, 0.25)",
            }}
          />
          {t.SummaryCount(projectCount, STATUS_STEPS[step].label)}
        </Typography>
      ))}
    </Box>
  );
}
